import { IStateApp } from '@/store/modules/app'
import { APIVersion } from '@/type/version'

export default {
  setApiVersion(state: IStateApp, { version }: APIVersion) {
    const splitIndex = version.indexOf('+')
    state.apiVersion = splitIndex !== -1 ? version.substring(0, splitIndex) : version
  }
}
